module.exports = __webpack_public_path__ + "img/scene_3.9fe36ad1.jpg";